export default "__VITE_ASSET__DtQejBRJ__"